// @flow

import * as React from 'react';

type Props = {
  width?: string,
  height?: string,
  color?: string,
};

export const Error = ({ width, height, color }: Props) => (
  <svg
    viewBox="0 0 24 24"
    width={width || '100%'}
    height={height || '100%'}
    style={{ fill: color || 'currentColor' }}
  >
    <path d="M3 12c0-2.263.916-4.406 2.3-5.99a18437.51 18437.51 0 0 0 12.696 12.697A8.964 8.964 0 0 1 12 21c-4.963 0-9-4.037-9-9zm18 0c0 2.263-.916 4.406-2.3 5.99A18437.496 18437.496 0 0 0 6.005 5.292 8.964 8.964 0 0 1 12 3c4.963 0 9 4.037 9 9zM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2" />
  </svg>
);
